import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const ProfileChartsDataContext = createContext();

const ProfileChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: JSON.stringify(filters.year?.value || filters.year || currentYear),
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_PROFILE_BY_PEOPLE_TYPE,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/byPeopleType'
        },
        filterParams
    );

    const byGenderData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_PROFILE_BY_GENDER,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/byGender'
        },
        filterParams
    );

    const byAgeData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_PROFILE_BY_AGE,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/byAge'
        },
        filterParams
    );

    const bySkinColorData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_PROFILE_BY_SKIN_COLOR,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/bySkinColor'
        },
        filterParams
    );

    const byProfessionData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_PROFILE_BY_PROFESSION,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/byProfession'
        },
        filterParams
    );

    const chartData = {
        byPeopleTypeAnual: data?.anualEvolution || [],
        byPeopleTypeMonth: data?.monthEvolution || [],
        byGenderAnual: byGenderData?.data?.anualEvolution || [],
        byGenderMonth: byGenderData?.data?.monthEvolution || [],
        byAgeAnual: byAgeData?.data?.anualEvolution || [],
        byAgeMonth: byAgeData?.data?.monthEvolution || [],
        bySkinColorAnual: bySkinColorData?.data?.anualEvolution || [],
        bySkinColorMonth: bySkinColorData?.data?.monthEvolution || [],
        byProfessionAnual: byProfessionData?.data?.anualEvolution || [],
        byProfessionMonth: byProfessionData?.data?.monthEvolution || []
    }

    return (
        <ProfileChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ProfileChartsDataContext.Provider>
    );
};

export default ProfileChartsDataProvider;
